import { useState, useEffect, useCallback } from 'react';
import debounce from 'lodash.debounce';
import { useQuery } from '@tanstack/react-query';

import useDropdown from '../../lib/hooks/useDropdown';

import { get } from '../../lib/api';

export const useSearchUsers = () => {
  const {
    dropdownRef,
    buttonRef,
    showDropdown,
    setShowDropdown,
  } = useDropdown();
  const [nameQuery, setNameQuery] = useState('');
  const { data = { users: [] }, refetch, isLoading, fetchStatus } = useQuery(
    ['searchUsers', nameQuery],
    () => get('/api/client_admin/users', { name_query: nameQuery }),
    { enabled: false },
  );

  useEffect(() => {
    if (nameQuery.length > 0) {
      setShowDropdown(true);
    } else {
      setShowDropdown(false);
    }
  }, [nameQuery.length, setShowDropdown]);

  const debouncedSearch = useCallback(
    debounce(value => {
      if (value.length > 0) {
        refetch();
      }
    }, 500),
    [],
  );

  const handleSearch = e => {
    setNameQuery(e.target.value);
    debouncedSearch(e.target.value);
  };

  const showEmptyResult =
    !isLoading && fetchStatus === 'idle' && data.users.length === 0;

  return {
    usersList: data.users,
    handleSearch,
    nameQuery,
    showDropdown,
    dropdownRef,
    inputRef: buttonRef,
    setNameQuery,
    setShowDropdown,
    showEmptyResult,
  };
};
